module.exports = __webpack_public_path__ + "static/media/ha1.190a413e.jpg";